/**
 * DescriptionLeftMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled description left mask.
 */
const DescriptionLeftMask = styled.div`
  background: linear-gradient(
    252deg,
    rgba(0, 0, 0, 0) 37.88%,
    #000 50.69%,
    #202020 71.22%,
    #212121 73.12%,
    #323232 80.52%
  );
  bottom: 0;
  height: ${1080 * Screen.widthRatio}px;
  left: 0;
  position: absolute;
  width: ${1920 * Screen.widthRatio}px;
  z-index: 1;
`;

export default DescriptionLeftMask;
